export default __webpack_public_path__ + "static/media/Grips of the Great Impi.bda919a1.jpg";